<template>
<div id="rightContBan">
<div class="right-cont-banner" id="shareRightContBan">
    <!-- <div class="cloud-icon" @click.stop="toMainHomePage()">
        <div class="cloud-icon-position">
            <div class="cloud-image"></div>
            <div class="cloud-name-description">{{$t('language.leftBanner.cloudEscription')}}</div>
        </div>
    </div> -->
    <!-- <div class="tourest-text" v-show="resetEmail" :style="{width:getTxtWidth()}" style="background-color:#eceff6">
        <span>{{$t('language.rightTopBanner.rememberOriginal')}}<span style="color:#8a96e3">{{email}}</span> {{$t('language.rightTopBanner.andPassword')}}: <span style="color:#8a96e3">{{password}}</span> <br>
            <font v-html="$t('language.rightTopBanner.bindEmailOpen')"></font>
        </span>
        <div class="icon-util top-close top-close-button" @click.stop="resetEmail=false;"></div>
        <button class="copyToClipBtn" @click="copyInfo($event)">{{$t('language.common.copy')}}</button>
    </div> -->
    <div class="browser-prompt" v-show="iePromptShow" :style="{width:getPromptWidth()}" style="background-color:#eceff6">
        <span>
            <font v-html="$t('language.rightTopBanner.browserPrompt')"></font>
        </span>
        <div class="icon-util top-close top-close-button" @click.stop="iePromptShow=false;"></div>
    </div>
    <div class="personal-center">
        <div class="center-left">
            <div class="icon-util personal personal-left" @click.stop="personalMenuOpen()" v-clickoutside="personalMenuClose" v-show="isLogin">
                <div class="personal-menu" v-show="personalMenuShow" ref="personalMenu">
                    <div class="personal-account">
                        <div class="personal-account-item" :title="email">{{email}}</div>
                    </div>
                    <div class="personal-info" @mouseenter="changePass()" @mouseleave="selectMenuIndex=-1">
                        <div class="icon-util properties personal-icon-position"></div>
                        <div class="personal-item">{{$t('language.rightTopBanner.settings')}}</div>
                        <div class="icon-util pull-triangle personal-moremenu-position"></div>
                        <div class="personal-setting-menu" v-show="selectMenuIndex==0" ref="setMenuOne">
                            <div class="personal-info" v-show="!judgeTourist()" @click.stop="changeNameOpen()">
                                <span class="setting-position" ref="changeName"> {{$t('language.rightTopBanner.changeName')}}</span>
                            </div>
                            <div class="personal-info" v-show="!judgeTourist()&&!judgeThird()" @click.stop="changePassOpen()">
                                <span class="setting-position" ref="changePassWord"> {{$t('language.rightTopBanner.changePassword')}}</span>
                            </div>
                            <div class="personal-info" v-show="judgeTourist()" @click.stop="bindEmailOpen()">
                                <span class="setting-position">{{$t('language.rightTopBanner.bindEmail')}}</span>
                            </div>
                            <div class="personal-info" @click.stop="deleteAccountOpen()">
                                <span class="setting-position">{{$t('language.rightTopBanner.deleteAccount')}}</span>
                            </div>
                        </div>
                    </div>
                    <div class="personal-info" @mouseenter="selectMenuIndex=1" @mouseleave="selectMenuIndex=-1">
                        <div class="icon-util multi-language personal-icon-position"></div>
                        <div class="personal-item">{{$t('language.rightTopBanner.language')}}</div>
                        <div class="icon-util pull-triangle personal-moremenu-position"></div>
                        <div class="personal-setting-menu" v-show="selectMenuIndex==1">
                            <div class="personal-info" v-for="(item, index) in languageArr" :key="index" @click.stop="checkLanguage(index)">
                                <div class="icon-util language-check language-check-position" v-show="checkLanguageIndex==index"></div>
                                <span class="language-position">{{item}}</span>
                            </div>
                        </div>
                    </div>
                    <div class="personal-info" @mouseenter="menuHelpShow()" @mouseleave="selectMenuIndex=-1">
                        <div class="icon-util help personal-icon-position"></div>
                        <div class="personal-item ">{{$t('language.rightTopBanner.help')}}</div>
                        <div class="icon-util pull-triangle personal-moremenu-position"></div>
                        <div class="personal-setting-menu" v-show="selectMenuIndex==2" ref="setMenuTwo">
                            <div class="personal-info" v-for="(item, index) in helpArr" :key="index" @click="openHelpLink(index)">
                                <span class="setting-position" ref="detail">{{item}}</span>
                            </div>
                        </div>
                    </div>
                    <div class="personal-info" @click.stop="logout()">
                        <div class="icon-util logout personal-icon-position" style="margin: 0 1px 0 5px!important;"></div>
                        <div class="personal-item">{{$t('language.rightTopBanner.logout')}}</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="center-right">
            <div class="center-right-position" v-show="isLogin">
                <button class="upgrade-button" @click="switchToPay()" v-if="user&&user.payType=='Lifetime'">
                    <img v-if="payBtn.img" :src="payBtn.img" />
                    <div class="payTxt">{{payBtn.txt}}</div>
                </button>
                <button class="upgrade-button" @click="switchToPay()" v-if="user&&user.payType!='Lifetime'">
                    <div v-if="timerExpired">
                        <div class="right-top-icon icon starImg"></div>
                        <div class="payTxt">{{$t('language.valentineSale.payTxt')}}</div>
                        <div class="active-button"></div>
                    </div>
                    <div v-if="!timerExpired">
                        <div v-if="payBtn.img" class="right-top-icon icon"  :class="payBtn.img"></div>
                        <div class="payTxt">{{payBtn.txt}}</div>
                    </div>
                </button>
                <div class="right-content">
                    <div class="progress-bar">
                        <div :class="btnColor=='grey'?'':'inner-progress-bar'" :style="{width:(usedTraffic/totalTraffic)*100+'%'}"></div>
                    </div>
                    <div class="drive-space" v-if="totalTraffic!=-1">
                        {{$t('language.rightTopBanner.traffic')}}:{{usedTraffic|formatByteForBanner}}/{{totalTraffic|formatByteForBanner}}
                    </div>
                    <div class="drive-space" v-else>
                        {{$t('language.rightTopBanner.traffic')}}:{{usedTraffic|formatByteForBanner}}/{{$t('language.rightTopBanner.unlimited')}}
                    </div>
                </div>
            </div>
            <div class="center-right-position" v-show="!isLogin" style="border-left:0">
                <div style="padding-left: 25px;" class="center-right-position-sign" @click="openToSignUp()" v-ga="{eventAction:'click',eventCategory:'/sign.html',eventLabel:'/share-top-right'}">
                    <button class="sign-up-btn">{{$t('language.login.signUp')}}</button>
                </div>
                <div class="center-right-position-sign" @click="signInDialogShow()">
                    <button class="sign-in-btn">{{$t('language.login.signIn')}}</button>
                </div>
            </div>
        </div>
    </div>

</div>
 <notificationsDialog ref="notificationsDialog"></notificationsDialog>
</div>
</template>
<script>
import commonUtils from "@/js/workspace/common_util.js";
import cartImg from '@/assets/images/workspace/cart.png';
import unlimitImg from '@/assets/images/workspace/unlimited.png';
import commonstate from '@/js/constant.js';
import notificationsDialog from '@/components/popup/personal_center_popups/notifications_popup';
export default {
    data: function () {
        return {
            personalMenuShow: false,
            languageArr: ['English', 'Deutsch', 'Français', 'Português','Español','Italiano','日本語', '繁體中文', '简体中文'],
            helpArr: [this.$t('language.rightTopBanner.tutorials'), this.$t('language.rightTopBanner.faq'), this.$t('language.rightTopBanner.contact'), this.$t('language.rightTopBanner.limitsClouds')],
            selectMenuIndex: -1,
            checkLanguageIndex: 0,
            email: '',
            totalTraffic: '',
            usedTraffic: '',
            touriest: false,
            password: '',
            resetEmail: false,
            user: commonUtils.getUser(),
            payBtn: {},
            isLogin: false, //是否登录
            btnColor: '',
            iePromptShow:false,
            timerExpired: false,//判断活动是否过期
        }
    },
    components:{
         notificationsDialog
    },
    created() {
        let user = commonUtils.getUser();
        if(!user){
            this.isLogin = false;
            return;
        }else{
            this.isLogin = true;
        }
        this.createPayBtn(user);
        if(user.loginType&&user.loginType!="sub"&&!(commonstate.activeLoginTypeList.includes(user.loginType))&&!(commonstate.channelTypeList.includes(user.loginType))){
          this.email = user.email.replace("T","");
         }else{
         this.email = user.email
         }
         this.usedTraffic = user.usedBytes;
        // if(user.vip&&user.payLevel>1){
        // this.usedTraffic = user.payUsedTraffic?user.payUsedTraffic:0;
        // }
        this.totalTraffic = user.totalBytes;
        this.$i18n.locale = localStorage.getItem('locale') || 'english';
        switch (this.$i18n.locale) {
            case 'english':
                this.checkLanguageIndex = 0;
                break;
            case 'deutsch':
                this.checkLanguageIndex = 1;
                break;
            case 'france':
                this.checkLanguageIndex = 2;
                break;
            case 'portuguese':
                this.checkLanguageIndex = 3;
                break;
            case 'spanish':
                this.checkLanguageIndex = 4;
                break;
            case 'italian':
                this.checkLanguageIndex = 5;
                break;
            case 'japanese':
                this.checkLanguageIndex = 6;
                break;
            case 'traditionalChinese':
                this.checkLanguageIndex = 7;
                break;
            case 'chinese':
                this.checkLanguageIndex = 8;
                break;
        }
    },
    inject: ["reload"],
    mounted() {
        //禁用该区域的拖拽上传功能
        commonUtils.dragDisAble('shareRightContBan',this);
        let that = this;
        if (document.getElementById("bindEmailOpen")) {
            document.getElementById("bindEmailOpen").onclick = function () {
                that.$parent.$refs.bindEmail.bindEmailShow = true;
                that.personalMenuShow = false;
            }
        }
        //获取用户
        let Base64 = require('js-base64').Base64;
        let user = commonUtils.getUser();
        if(!user){
            this.isLogin = false;
            return;
        }else{
            this.isLogin = true;
            if(user.password){
                this.password = user.password;
                if(user.password.length>10){
                    this.password = new String(Base64.decode(user.password),"utf-8");
                }
            }
            //如果用户没密码信息则不是临时账号
            if (!this.password||user.password.length>12) {
                this.resetEmail = false;
                this.judgeIeBrowserTimeMore();
            } else {//显示临时账号弹窗
                this.resetEmail = true;
                //过一段时间后关闭游客弹窗，并判断是否是IE浏览器
                let t = setTimeout(function () {
                    that.resetEmail = false;
                    that.judgeIeBrowser();
                    clearTimeout(t);
                }, 10000);
            }
        }
        this.timerExpired = this.getTimerExpired();
        if(!this.isLogin){
            return
        }
    },
    methods: {
        judgeTourist(){//判断是否是游客账号
            let user = commonUtils.getUser();
            if(user){
                let result;
                 if(user.password){
                    result=true;
                 }else{
                   if(user.email){
                   if(!commonstate.emailpattern.test(user.email)){
                       result=true;//如果用户的邮箱不符合格式则是临时账号
                   }else{
                       result=false;
                   }
                   }else{
                        result=true;//如果用户邮箱都不存在则不是邮箱账号
                   }
                 }
             return result;
            }
        },
        judgeThird(){//判断是否是第三方登录账号
            let user = commonUtils.getUser();
            if(user&&user.loginType&&user.loginType!="sub"&&!(commonstate.activeLoginTypeList.includes(user.loginType))&&!(commonstate.channelTypeList.includes(user.loginType))){
                return true;
            }
            return false;
        },
        judgeIeBrowser(){
           let that=this;
           var userAgent = navigator.userAgent; //取得浏览器的userAgent字符串
            var isOpera = userAgent.indexOf("Opera") > -1;
           if (userAgent.indexOf("compatible") > -1 && userAgent.indexOf("MSIE") > -1&& !isOpera) {//判断是否IE浏览器
            that.iePromptShow=true;
               let t1 = setTimeout(function () {
                 that.iePromptShow=false;
                  clearTimeout(t1);
            }, 5000);
           }; 
        },
        judgeIeBrowserTimeMore(){
           let that=this;
           var userAgent = navigator.userAgent; //取得浏览器的userAgent字符串
           var isOpera = userAgent.indexOf("Opera") > -1;
           if (userAgent.indexOf("compatible") > -1 && userAgent.indexOf("MSIE") > -1&& !isOpera) {//判断是否IE浏览器
            that.iePromptShow=true;
               let t1 = setTimeout(function () {
                 that.iePromptShow=false;
                  clearTimeout(t1);
            }, 10000);
           }; 
        },
        getTxtWidth() {
            let result;
            if (this.$i18n.locale == 'english') {
                result = 650 + 'Px';
            }
            if (this.$i18n.locale == 'deutsch') {
                result = 800 + 'Px';
            }
            if (this.$i18n.locale == 'france') {
                result = 800 + 'Px';
            }
            if (this.$i18n.locale == 'portuguese') {
                result = 700 + 'Px';
            }
            if (this.$i18n.locale == 'japanese') {
                result = 800 + 'Px';
            }
            if (this.$i18n.locale == 'traditionalChinese') {
                result = 600 + 'Px';
            }
            if (this.$i18n.locale == 'chinese') {
                result = 480 + 'Px';
            }
            if (this.$i18n.locale == 'spanish') {
                result = 800 + 'Px';
            }
            if (this.$i18n.locale == 'italian') {
                result = 650 + 'Px';
            }
            return result;
        },
        getPromptWidth() {
            let result;
            if (this.$i18n.locale == 'english') {
                result = 450 + 'Px';
            }
            if (this.$i18n.locale == 'deutsch') {
                result = 500 + 'Px';
            }
            if (this.$i18n.locale == 'france') {
                result = 550 + 'Px';
            }
            if (this.$i18n.locale == 'portuguese') {
                result = 500 + 'Px';
            }
            if (this.$i18n.locale == 'japanese') {
                result = 450 + 'Px';
            }
            if (this.$i18n.locale == 'traditionalChinese') {
                result = 400 + 'Px';
            }
            if (this.$i18n.locale == 'chinese') {
                result = 400 + 'Px';
            }
            if (this.$i18n.locale == 'spanish') {
                result = 500 + 'Px';
            }
            if (this.$i18n.locale == 'italian') {
                result = 500 + 'Px';
            }
            return result;
        },
        createPayBtn(user) {
            var btnTxt;
            var btnImg;
            if (user.vip) {
                if (user.payLevel > 1) {//大于1为有限
                    btnImg = cartImg;
                    btnTxt = this.$t('language.rightTopBanner.purTraffic');
                } else {//小于等于1为无限用户
                    this.btnColor = 'grey';
                    btnImg = unlimitImg;
                    btnTxt = this.$t('language.rightTopBanner.unlimitedPlan');
                }
            } else {
                if(!user.totalBytes&&!user.usedBytes){
                    this.btnColor = 'grey';
                }
                btnImg = cartImg;
                btnTxt = this.$t('language.rightTopBanner.upgrade');
            }
            this.payBtn['txt'] = btnTxt;
            if (btnImg) {
                this.payBtn['img'] = btnImg;
            }
        },
        switchToPay() {
            this.user = commonUtils.getUser();
            //活动用户直接跳转活动链接
            if(this.user.vip && this.user.payType=='a202301'){
                window.open("https://d-gogo.com/pages/multcloud-campaign");
                return;
            }
            if (this.user.vip && this.user.payLevel <= 1&&this.user.payType == 'Lifetime') {
                this.$toast({
                    text: this.$t('language.rightTopBanner.lifeTimeNotice'),
                    type: 'success',
                    idValue: "rightContBan"
                });
            } else {
                // if(this.timerExpired){
                //     window.location.href = commonstate.nowNewUrl+'/mc_project/paySysActivity';
                // }else{
                    window.location.href = commonstate.nowNewUrl+'/mc_project/paySys';
                // }
            }
        },
        onDrag: function (e) {
            e.stopPropagation();
            e.preventDefault();
        },
        personalMenuOpen() {
            this.personalMenuShow = true;
            let user = this.user;
            let reg = /^\w+((-\w+)|(\.\w+))*\@[A-Za-z0-9]+((\.|-)[A-Za-z0-9]+)*\.[A-Za-z0-9]+$/;
            if (reg.test(user.email)) {
                this.touriest = false;
            } else {
                this.touriest = true;
            }
        },
        personalMenuClose() {
            this.personalMenuShow = false;
            this.selectMenuIndex = -1;
        },
        openHelpLink(index) {
             let language = commonUtils.getLocaleToIndex(localStorage.getItem("locale"));
             let link;
            switch (index) {
                case 0:
                    if(language!='en'){
                     link='https://www.multcloud.com/'+language+'/tutorials/index.html';
                    }else{
                      link='https://www.multcloud.com/tutorials/index.html';
                    }
                    break;
                case 1:
                     if(language!='en'){
                     link='https://www.multcloud.com/'+language+'/helps';
                     }else{
                      link='https://www.multcloud.com/helps';
                     }
                    break;
                case 2:
                     if(language!='en'){
                     link='https://www.multcloud.com/'+language+'/support';
                     }else{
                     link='https://www.multcloud.com/support';
                     }
                    break;
                case 3:
                    if(language!='en'){
                    link='https://www.multcloud.com/'+language+'/help/limitations.html';
                    }else{
                    link='https://www.multcloud.com/help/limitations.html';
                    }
                    break;
            }
             window.open(link, "_blank");
        },
        changePassOpen() {
            let user = commonUtils.getUser();
            this.$parent.$refs.changePass.confrimPassWord = '';
            this.$parent.$refs.changePass.newPassword = '';
            if(user.loginType&&user.loginType!="sub"&&!(commonstate.activeLoginTypeList.includes(user.loginType))&&!(commonstate.channelTypeList.includes(user.loginType))){
                this.$parent.$refs.changePass.email = user.email.replace("T","");
            }else{
                 this.$parent.$refs.changePass.email = user.email;
            }
            this.$parent.$refs.changePass.changePassShow = true;
            this.personalMenuShow = false;
        },
        changeNameOpen() {
            let user = commonUtils.getUser();
            this.$parent.$refs.changeName.userName = user.username;
            if(user.loginType&&user.loginType!="sub"&&!(commonstate.activeLoginTypeList.includes(user.loginType))&&!(commonstate.channelTypeList.includes(user.loginType))){
                this.$parent.$refs.changeName.email = user.email.replace("T","");
            }else{
                 this.$parent.$refs.changeName.email = user.email;
            }
            this.$parent.$refs.changeName.changeNameShow = true;
            this.personalMenuShow = false;
        },
        checkLanguage(index) {
            if (this.checkLanguageIndex == index) {
                this.personalMenuShow = false;
            } else if (this.checkLanguageIndex != index) {
                this.reload();
                this.languageIndex = index;
                switch (index) {
                    case 0:
                        this.$i18n.locale = 'english';
                        break;
                    case 1:
                        this.$i18n.locale = 'deutsch';
                        break;
                    case 2:
                        this.$i18n.locale = 'france';
                        break;
                    case 3:
                        this.$i18n.locale = 'portuguese';
                        break;
                     case 4:
                        this.$i18n.locale = 'spanish';
                        break;
                     case 5:
                        this.$i18n.locale = 'italian';
                        break;
                    case 6:
                        this.$i18n.locale = 'japanese';
                        break;
                    case 7:
                        this.$i18n.locale = 'traditionalChinese';
                        break;
                    case 8:
                        this.$i18n.locale = 'chinese';
                        break;
                    default:
                        this.$i18n.locale = 'english';
                        break;
                }
                localStorage.setItem('locale', this.$i18n.locale);
            }
        },
        bindEmailOpen() {
            this.$parent.$refs.bindEmail.bindEmailShow = true;
            this.personalMenuShow = false;
        },
        deleteAccountOpen() {
            let that = this;
            let user=commonUtils.getUser();
            let password;
            const vm = window.vm.$children[0].$refs.routerView.$refs.routView;
            if(user.password){
                password=user.password;
            }
            this.$parent.$refs.deleteAccount.deleteAccountShow = true;
            this.personalMenuShow = false;
            commonUtils.refreshUserInfo(this,function(res){
                if(password){
                    user=res;
                    user.password=password;
                    localStorage.setItem("user", JSON.stringify(user));
                    that.$cookies.set("user",JSON.stringify(user),"7d");
                }
            });
        },
        logout() {
            let that = this;
            let ud = this.user.id;
            let exitData = {
                ud: ud
            }
            that.Utils.doUserHaveLoginRequest("exit", exitData).then(result => {
                  let key = 'monthLy'+this.user.id;//将用户第一次点击的时间点存入缓存
                  let firstTime = localStorage.getItem(key);
                if (result.status == 200) {
                    let language = commonUtils.caseIndexLanguage(localStorage.getItem("locale"));
                    that.$store.commit("setUsersDrives", []);
                    commonUtils.logout_clear();
                    location.reload();
                }else{
                    if("saltInvalid"===result.reason){
                        this.$toast({
                            text: this.$t('language.exception.saltInvalid'),
                            type: 'fail',
                            idValue: "shareRightContBan",
                        });
                    }
                    commonUtils.logout_clear();
                }
                if(firstTime){
                        localStorage.setItem(key,firstTime);    
                }
            });
        },
        getNotifications() {
            let that = this;
            commonUtils.getNotifications(this);
        },
        copyInfo(e) {
            let user = this.user;
            let text = 'Welcome to use MultCloud(https://www.multcloud.com/)' + '\n' + 'Username:' + user.username + '\n' + 'Password:' + this.password + '';
            const clipboard = new this.clipboard(e.target, {
                text: () => text
            })
            clipboard.on('success', e => {
                this.$toast({
                    text: 'Copy successfully!',
                    type: 'success',
                    idValue: "shareRightContBan"
                });
                // 释放内存
                clipboard.off('error');
                clipboard.off('success');
                clipboard.destroy();
            });
            clipboard.on('error', e => {
                // 释放内存
                clipboard.off('error');
                clipboard.off('success');
                clipboard.destroy();
            });
            clipboard.onClick(e);
        },
        changePass() {
            this.selectMenuIndex = 0;
            this.$refs.setMenuOne.style.width = this.$refs.changePassWord.innerText.length * 7 + 20 + 'px/*no*/';
        },
        menuHelpShow() {
            this.selectMenuIndex = 2;
            let divDom = this.$refs.detail[3];
            this.$refs.setMenuTwo.style.width = divDom.innerText.length * 7 + 25 + 'px/*no*/';;
        },



        //以下为新加
        signInDialogShow() {//打开signIn弹窗
          this.$parent.$refs.signInDialog.signInShow = true;
          this.$parent.shareRightMenuShow = false;
        },
        openToSignUp() {
            this.$parent.$refs.signInDialog.state = "signUp";
            this.$parent.$refs.signInDialog.signInShow = true;
            this.$parent.shareRightMenuShow = false;
        },
        toMainHomePage() {
            window.open(commonstate.nowNewUrl + "/home");
        },
        getTimerExpired(){
            //新春活动只针对繁体
            // if(localStorage.getItem("locale")!="traditionalChinese"){
            //     return false;
            // }
            return false;
        },
    },
}
</script>

<style scoped>

@charset "utf-8";

.payTxt {
    float: left;
}

.copyToClipBtn {
    border-style: none;
    outline: 0;
    border-radius: 5px;
    /*no*/
    cursor: pointer;
    color: #fff;
    background-color: #5166bd;
    float: right;
    position: absolute;
    top: 7px;
    /*no*/
    right: 40px;
    /*no*/
    bottom: 0;
}

.tourest-text {
    width: 650px;
    /*no*/
    height: 45px;
    /*no*/
    position: absolute;
    margin: auto;
    top: 0;
    /*no*/
    bottom: 0;
    left: -25%;
    right: 0;
    border: 1px solid #8a96e3;
    /*no*/
    border-radius: 5px;
    /*no*/
    font-size: 12px;
    /*no*/
    z-index: 1;
    box-sizing: border-box;
    padding: 5px 10px;
    /*no*/
    line-height: 18px;
    /*no*/
}
.browser-prompt {
    width: 450px;
    /*no*/
    height: 45Px;
    position: absolute;
    margin: auto;
    top: 0;
    /*no*/
    bottom: 0;
    left: -25%;
    right: 0;
    border: 1px solid #8a96e3;
    /*no*/
    border-radius: 5px;
    /*no*/
    font-size: 12px;
    /*no*/
    z-index: 1;
    box-sizing: border-box;
    padding: 5px 10px;
    /*no*/
    line-height: 35px;
    /*no*/
}
.personal-icon-position {
    float: left;
    position: relative;
    top: 7px;
    /*no*/
    left: 15px;
    /*no*/
    top: 10px !important; /*no*/
    margin: 0px 3px !important;/*no*/
}

.personal-moremenu-position {
    float: right;
    position: relative;
    top: 7px;
    /*no*/

}

/*右上导航栏*/
.right-cont-banner {
    width: 100%;
    height: 60px;
    /*no*/
    position: relative;
    /*background-color: #414B81;*/
    float: right;
}

.pentagram {
    width: 20px;
    /*no*/
    height: 10px;
    /*no*/
    background-position: -605px -60px;
    /*no*/
}

.personal-left {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
}

.personal-center {
    height: 100%;
    float: right;
    margin-right: 30px;
    /*no*/
}

.upgrade-position {
    height: 25px;
    /*no*/
    line-height: 16px;
    /*no*/
}

.center-left {
    width: 60px;
    /*no*/
    float: left;
    height: 100%;
    position: relative;

}

.center-right {
    min-width: 275px;
    /*no*/
    float: left;
    height: 100%;
    position: relative;
}

.progress-bar {
    width: 160px;
    /*no*/
    background-color: #ECEEF7;
    height: 10px;
    /*no*/
    margin-left: 10Px;
}

/* .progress-bar>div {
    background-color: #5562b4;
    height: 100%;
} */

.upgrade-button {
    height: 25px;
    /*no*/
    background-color: #FFAA46;
    font-size: 14px;
    /*no*/
    float: right;
    text-align: center;
    line-height: 25Px;
}

.upgrade-button:hover {
    background-color: #F1C159;
}

.upgrade-button:active {
    background-color: #FFAA46;
}

.upgrade-button img {
    margin-right: 5Px;
    vertical-align: middle;
    float: left;
    position: relative;
    top: 2Px;
}

.pentagram-positon {
    float: left;
    margin-right: 2%;
    position: relative;
    top: -2px;
    /*no*/
}

.drive-space {
    /*color: #E2E3EA;*/
    color: rgba(0,0,0,.55);
    height: 66%;
    font-size: 12px;
    /*no*/
    text-align: center;
    line-height: 25Px;
}

.right-content {
    /*no*/
    height: 100%;
    float: left;
    margin-right: 20Px;
}

.center-right-position {
    width: 100%;
    height: 27px;
    /*no*/
    border-left: 1px solid #E4E9F3;
    /*no*/
    margin-top: 20Px;
}

.personal-menu {
    width: 220px;
    /*no*/
    height: 189px;
    /*no*/
    border: 1px solid #8a96e3;
    /*no*/
    background: #FFF;
    position: absolute;
    z-index: 600;
    top: 100%;
    right: 0px;
    /*no*/
}

.personal-setting-menu {
    position: absolute;
    z-index: 900;
    min-width: 160px;
    /*no*/
    border: 1px solid #8a96e3;
    /*no*/
    left: 220px;
    /*no*/
    background: #fff;

}

.language-position {
    float: left;
    position: absolute;
    left: 50px;
    /*no*/
}

.setting-position {
    float: left;
    position: absolute;
    left: 20px;
    /*no*/
}

.personal-account {
    width: 100%;
    height: 50px;
    /*no*/
    border-bottom: 1px solid #f8f8f8;
    /*no*/
    display: table;
    text-align: center;
}

.personal-info {
    width: 100%;
    height: 34.6px;
    /*no*/
    color: #6f7886;
    line-height: 35px;
    /*no*/
    font-size: 14px;
    /*no*/
    float: left;
}

.personal-logout {
    width: 100%;
    height: 35px;
    /*no*/
    border-top: 1px solid #f8f8f8;
    /*no*/
    line-height: 35px;
    /*no*/
    font-size: 14px;
    /*no*/
    color: #6f7886;
}

.personal-info:hover,
.personal-logout:hover {
    background: #d7e7ff;
}

.personal-item {
    position: relative;
    left: 25px;
    /*no*/
    float: left;
}

.personal-account-item {
    max-width:45Px;
    /*no*/
    text-overflow: ellipsis;
    overflow: hidden !important;
    white-space: nowrap !important;
    vertical-align: middle;
    display: table-cell;
    padding: 0 10Px 0 10Px;
}

.personal-plan {
    color: #a3adbd;
    font-size: 12px;
    /*no*/
    float: left;
    position: relative;
    left: 45px;
    /*no*/
}

.personal-account-position {
    position: relative;
    top: 13px;
    /*no*/
}

.language-check-position {
    position: relative;
    float: left;
    top: 7px;
    /*no*/
    left: 19px;
    /*no*/
}

.shop_cart {
    width: 14px;
    /*no*/
    height: 20px;
    /*no*/
    background-image: url("../../assets/images/workspace/cart.png");
    float: left;
}

.unlimited {
    width: 20px;
    /*no*/
    height: 20px;
    /*no*/
    background-image: url("../../assets/images/workspace/unlimited.png");
    float: left;
}

.upgrade-class {
    float: left;
    margin-left: 5px;
    /*no*/
    line-height: 20px;
    /*no*/
}

.top-close-button {
    float: right;
    position: absolute;
    top: 11Px;
    right: 10Px;
    cursor: pointer;
}
.cloud-icon {
    height: 0.59rem;
    /*no*/
    box-sizing: border-box;
    padding-left: 1%;
    display: flex;
    align-items: center;
    vertical-align: middle;
    line-height: 50%;
    float: left;
    width: 15%;
    background-color: #414B81;
}

.cloud-icon {
    width: 300px;/*no*/
    cursor: pointer;
}

.cloud-icon-position {
    width: 90%;
    height: 80%;
    margin: 0.1rem 0 0 0.2rem;
}

.cloud-image {
    width: 173px;
    /*no*/
    height: 39px;
    /*no*/
    background-image: url("../../assets/images/logo.png");
    background-size: cover;
    position: relative;
    top: 0px;
    /*no*/
    float: left;
}

.cloud-name-description {
    font-size: 12Px;
    color: #FFF;
    position: relative;
    left: 70Px;
    margin: 0;
    top: -11Px;
    float: left;
    
    line-height: 13Px;
}

.center-right-position-sign {
    float:right;
}

.center-right-position-sign span:hover {
    text-decoration: underline white;
    cursor: pointer;
}

.sign-in-btn {
    background-color: #fff;
    border: 1px solid #5166bd;/*no*/
    width: 100px;/*no*/
    color: #5166bd;
    border-radius: 5px;/*no*/
}

.sign-up-btn {
    width: 100px;/*no*/
    border-radius: 5px;/*no*/
}

.inner-progress-bar {
    background-color: #5562B4;
    height: 100%;
    max-width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/common/share_right_top_banner.vue